import React, {Component} from 'react';
import {
    Col,
    Container,
    FormFeedback,
    FormGroup,
    FormText,
    Input,
    Label,
    Button as Button2,
    Row,
    CustomInput
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import DateInput from "react-datepicker";
import moment from "moment";
import {DABBL_COLOR, isAlphaNumeric} from "../../../shared/utils";
import ColorInput from '../../../shared/components/ColorInput';
import Editor,{ Quill } from 'react-quill';


class EditPromotion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ctaColorValid: true,
            isUpdating: false,
            isActivating: false,
            campaign: null,
            upc: '',
            priority: 9,
            type: 'LEAD',
            placement:'DEAL',
            method:'GET',
            error: null,
            validateForm: false
        }
    }

    componentWillMount() {
        const {promotion} = this.props
        if (promotion) {
            this.setState({...promotion,
                startDate: promotion.startDate ? moment(moment.utc(promotion.startDate).format('LL')).startOf('day') : moment(),
                endDate: promotion.endDate ? moment(moment.utc(promotion.endDate).format('LL')).startOf('day') : moment(),
                ctaColor: promotion.ctaColor || DABBL_COLOR,
                codes: promotion.codes || [],
                count: promotion.count || 0,
                shouldSubmitCodes: false,
                url: promotion.callback && promotion.callback.url,
                method: promotion.callback && promotion.callback.method || 'GET',
                requiredFields: promotion.callback && promotion.callback.requiredFields,
                blockedDomains: promotion.callback && promotion.callback.blockedDomains,
                validateForm: true});
        } else {
            this.setState({
                name: '',
                imageURL: '',
                headline: '',
                message: '',
                legal: '',
                ctaUrl: '',
                ctaCopy: '',
                ctaColor: DABBL_COLOR,
                startDate: moment(),
                endDate:  moment(this.state.startDate).add(7, "day"),
                codes: [],
                count: 0,
                shouldSubmitCodes: true
            });
        }
    }

    componentDidMount(){
    }

    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.promotion && !this.props.promotion){
            const {promotion} = newProps
            this.setState({...promotion,
                name: promotion.name,
                brandId: promotion.brandId,
                imageURL: promotion.imageURL,
                status: promotion.status,
                priority: promotion.priority || 9,
                headline: promotion.headline,
                message: promotion.message,
                legal: promotion.legal,
                startDate: promotion.startDate ? moment(moment.utc(promotion.startDate).format('LL')).startOf('day') : moment(),
                endDate: promotion.endDate ? moment(moment.utc(promotion.endDate).format('LL')).startOf('day') : moment(),
                ctaUrl: promotion.ctaUrl,
                ctaCopy: promotion.ctaCopy,
                ctaColor: promotion.ctaColor,
                codes: promotion.codes || [],
                count: promotion.count || 0,
                validateForm: true,
                shouldSubmitCodes: false,
                url: promotion.callback && promotion.callback.url,
                method: promotion.callback && promotion.callback.method || 'GET',
                requiredFields: promotion.callback && promotion.callback.requiredFields,
                blockedDomains: promotion.callback && promotion.callback.blockedDomains,
                isCreate: false});
        }
    }

    handleColorChange(color) {
        const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
        if (isValid) {
            this.setState({
                ctaColor: color,
                ctaColorValid: isValid
            })
        } else {
            this.setState({ctaColorValid: isValid})
        }
    }

    clearCodes(e){
        e.preventDefault()
        this.setState({codes: [], shouldSubmitCodes: true, count: 0})
    }

    handleFileUploadChange(e){
        let reader = new window.FileReader();
        reader.onload = (e1) => {
            let codesToAdd = reader.result.split(/[,(\r?\n)\n]/).filter((code) => (code !== ''))
            let codes = this.state.codes.concat(codesToAdd)
            this.setState({codes: codes, shouldSubmitCodes: true, count: codes.length})
            // for(let [key, upc] in upcs) {
            //     console.log(upc)
            // }
        }
        reader.readAsText(e.target.files[0]);
        e.target.value = ''
    }

    isValidPromotion() {
        const {name, imageURL, headline, message, legal, startDate, endDate, ctaUrl, ctaCopy, ctaColor, codes, type, shouldSubmitCodes, ctaColorValid, userSplit, fixedRevenue} = this.state
        return name && imageURL && headline && message && startDate < endDate && ctaCopy && ctaCopy.length <= 16 && ctaColor  && ctaColor && ctaColorValid
            && (type === 'AFFILIATE' || type === 'LEADGEN' || (shouldSubmitCodes && codes && codes.length > 0 || !shouldSubmitCodes))
    }

    handleSubmit(data) {
        console.log(this.isValidPromotion())
        if (!this.isValidPromotion()) {
            this.setState({validateForm: true})
            return
        }
        const promotion = this.props.promotion || {}
        const {isCreate, loadPromotions, brandId} = this.props
        const {name, imageURL, headline, message, legal, startDate, endDate, placement, ctaUrl, ctaCopy, ctaColor, codes, type, shouldSubmitCodes, priority, fixedRevenue, userSplit, method, url, requiredFields, blockedDomains} = this.state
        const callback = this.buildCallback()
        const requestData = {
            ...(name !== promotion.name && {name: name}),
            ...(brandId !== promotion.brandId && {brandId: brandId}),
            ...(imageURL !== promotion.imageURL && {imageURL: imageURL}),
            ...(priority !== promotion.priority && {priority: priority}),
            ...(placement !== promotion.placement && {placement: placement}),
            ...(headline !== promotion.headline && {headline: headline}),
            ...(message !== promotion.message && {message: message}),
            ...(legal !== promotion.legal && {legal: legal}),
            ...((!promotion.startDate || startDate.format('LL') !== moment.utc(promotion.startDate).format('LL')) && {startDate: this.state.startDate.add(this.state.startDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...((!promotion.endDate || endDate.format('LL') !== moment.utc(promotion.endDate).format('LL')) && {endDate: this.state.endDate.add(this.state.endDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...(ctaUrl !== promotion.ctaUrl && {ctaUrl: ctaUrl}),
            ...(ctaCopy !== promotion.ctaCopy && {ctaCopy: ctaCopy}),
            ...(ctaColor !== promotion.ctaColor && {ctaColor: ctaColor}),
            ...((isCreate || shouldSubmitCodes) && {codes: codes}),
            ...(type !== promotion.type && {type: type}),
            ...(userSplit !== promotion.userSplit && {userSplit: userSplit}),
            ...(fixedRevenue !== promotion.fixedRevenue && {fixedRevenue: fixedRevenue}),
            callback: callback,
            ...(isCreate && {status: 'DRAFT'})
        }
        this.setState({isUpdating: true, error: null});
            if (this.props.isCreate) {
                this.props.createPromotion({
                    brandId: brandId,
                    // agencyId: agencyId,
                    ...requestData
                })
                    .then((res) => {
                        return loadPromotions()
                        .then(() => {
                            this.props.history.replace(`${this.getBackLink()}/${res.instance.id}`);
                        })
                    })
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updatePromotion(this.props.promotion.id, requestData)
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        const { type, method, url, requiredFields, blockedDomains} = this.state
        const callback = this.buildCallback()
        this.props.updatePromotion(this.props.promotion.id, {status: 'ACTIVE', callback: callback})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdatePromotions: true}))
            .catch((err) => {
                console.log(err)
                try {
                    this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
                } catch (e) {
                    this.handleFailure({message: err.message.replace(/'/g, '"')})
                }
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false, shouldSubmitCodes: false, ...((this.state.type === 'PC_MULTIPLE') && {codes: []})});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.props.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.props.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    buildCallback() {
      const { type, method, url, requiredFields, blockedDomains} = this.state
      const callback = type === 'LEADGEN' ?  {
          method: method,
          url: url,
          requiredFields: requiredFields,
          blockedDomains: blockedDomains
      } : null
      return callback
    }

    render() {
        const { isCreate, promotion } = this.props;
        const {status, name, imageURL, headline, message, legal, startDate, endDate, priority, ctaUrl, ctaCopy, ctaColor, type, codes, ctaColorValid, count, shouldSubmitCodes, placement, fixedRevenue, userSplit, method, url, requiredFields, blockedDomains} = this.state

        const {
            isUpdating,
            isActivating,
            validateForm,
            error
        } = this.state;

        if (!isCreate && !promotion) {
            return <div>Promotion failed to load</div>
        }

        return (
            <Container className="EditPromotion">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Promotion' : `Edit ${promotion.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.setState({ name: e.target.value })}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Name is required</FormFeedback> }
                                    <FormText>This is internal only, not shown to users</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="imageURL" sm={4}>Tile Image Upload</Label>
                                <Col sm={8}>
                                    <DroppableFileInput
                                        id='imageURL'
                                        text='Tile Image'
                                        fileType='image'
                                        onChange={(image) => this.setState({imageURL: image.large})}
                                        cropperAspectRatio={1/2}
                                        existingFileName={imageURL ? imageURL .split('/').pop(): ''}
                                        existingFileURL={imageURL }
                                        warning={ imageURL  || !validateForm ? '' : 'Tile Image is required'}
                                    />
                                    <Row><Col sm={12}><FormText>MVP: Single image 1w x 2h dimension</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: d})}
                                    />
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should Tile go live?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='endDate'>End Date</Label>
                                <Col sm={8}>
                                    <DateInput id='endDate'
                                               className='form-control'
                                               disabled={!startDate}
                                               minDate={startDate || moment().startOf("day")}
                                               selected={endDate}
                                               onChange={(d) => {
                                                   this.setState({endDate: d});
                                               } }
                                    />
                                    {startDate >= endDate && validateForm &&
                                    <FormText color='danger'>End date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should Tile expire?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectPriority" sm={4}>Priority</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="selectPriority"
                                                 id='selectPriority'
                                                 defaultValue={priority}
                                                 invalid={(!priority || priority.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ priority: Number(e.target.value)})}>
                                        {[1,2,3,4,5,6,7,8,9].map((i) => (
                                            <option key={i} value={i}>{i}</option>
                                        ))}
                                    </CustomInput>
                                    <FormFeedback>Priority is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Priority defines sorting order for the user.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectPlacement" sm={4}>Placement</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="selectPlacement"
                                                 id='selectPlacement'
                                                 defaultValue={placement}
                                                 onChange={(e) => this.setState({ placement: e.target.value})}>
                                        <option key='DABBL' value='DABBL'>Downtime Dollars</option>
                                        <option key='DEAL' value='DEAL'>Deals and Discounts</option>
                                    </CustomInput>
                                    <FormFeedback>Placement is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>To what section place promo to?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="headline" sm={4}>Message Headline</Label>
                                <Col sm={8}>
                                    <Input name="headline"
                                           id="headline"
                                           defaultValue={headline}
                                           onChange={(e) => this.setState({ headline: e.target.value })}
                                           invalid={(!headline || headline.length === 0) && validateForm}/>
                                    {(!headline || headline.length === 0) && <FormFeedback>Message Headline is required</FormFeedback> }
                                    <FormText>What should the Headline read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="message" sm={4}>Message Body</Label>
                                <Col sm={8}>
                                    <Input name="message"
                                           id="message"
                                           defaultValue={message}
                                           onChange={(e) => this.setState({ message: e.target.value })}
                                           invalid={(!message || message.length === 0) && validateForm}/>
                                    {(!message || message.length === 0) && <FormFeedback>Message Body is required</FormFeedback> }
                                    <FormText>What should the message read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="legal" sm={4}>Message Legal Footer</Label>
                                <Col sm={8}>
                                    <Editor name="legal"
                                            id="legal"
                                        // className={`${warning.length>0 ? "is-invalid" : ""}`}
                                        // ref={(el) => this.quill = el}
                                        modules={ {toolbar:{ container:[['bold', 'italic', 'underline', 'link']]}}}
                                        value={legal}
                                        onChange={(value) => this.setState({ legal: value })}
                                         // invalid={(!legal || legal.length === 0) && validateForm}
                                    />
                                    {/*{(!legal || legal.length === 0) && <FormFeedback>Message Legal Footer is required</FormFeedback> }*/}
                                    <FormText>What should the Legal read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectType" sm={4}>Type</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="selectType"
                                                 id='selectType'
                                                 defaultValue={type}
                                                 onChange={(e) => this.setState({ type: e.target.value, count: 0, codes: [], shouldSubmitCodes: true, ctaUrl: e.target.value === 'LEADGEN' ? '' : ctaUrl})}>
                                        <option key='AFFILIATE' value='AFFILIATE'>Affiliate</option>
                                        <option key='PC_SINGLE' value='PC_SINGLE'>Single Code</option>
                                        <option key='PC_MULTIPLE' value='PC_MULTIPLE'>Multiple Codes</option>
                                        <option key='LEADGEN' value='LEADGEN'>Lead Gen</option>
                                    </CustomInput>
                                    <Row><Col sm={12}><FormText>Defines what type of brand promo it is.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            {type === 'LEADGEN' &&
                                <FormGroup row>
                                    <Label for="fixedRevenue" sm={4}>Downtime Dollars Commission Amount ($$)</Label>
                                    <Col sm={8}>
                                        <Input type="number"
                                               name="fixedRevenue"
                                               id="fixedRevenue"
                                               step='.01'
                                               defaultValue={fixedRevenue}
                                               invalid={(!fixedRevenue || Number(fixedRevenue) < 0.001 || Number(fixedRevenue) > 1) && validateForm}
                                               onChange={(e) => this.setState({fixedRevenue: Number(e.target.value) || 0})}/>
                                        <FormFeedback>{"Downtime Dollars commission amount should be between 0.001 and 1"}</FormFeedback>
                                        <FormText>How much will Downtime Dollars receive for each successful lead?</FormText>
                                    </Col>
                                </FormGroup>
                            }
                            {type === 'LEADGEN' &&
                                [
                                <FormGroup row>
                                    <Label for="userSplit" sm={4}>User Split (%)</Label>
                                    <Col sm={8}>
                                        <Input type="number"
                                               name="userSplit"
                                               id="userSplit"
                                               defaultValue={userSplit * 100}
                                               invalid={(!userSplit || Number(userSplit) < 0 || Number(userSplit) > 1) && validateForm}
                                               onChange={(e) => this.setState({userSplit: Number(e.target.value) / 100 || 0})}/>
                                        <FormFeedback>{"User split should be between 1 and 100"}</FormFeedback>
                                        <FormText>% to user; How much should user receive?</FormText>
                                    </Col>
                                </FormGroup>,
                                <FormGroup row>
                                    <Label for="valuePerUser" sm={4}>User Gets ($$)</Label>
                                    <Col sm={8}>
                                        <Input type="number"
                                               name="valuePerUser"
                                               id="valuePerUser"
                                               disabled={true}
                                               value={Math.round((Number(userSplit) || 0) * (Number(fixedRevenue) || 0) * 1000) / 1000}/>
                                        <FormText>How much $$ will user get?</FormText>
                                    </Col>
                                </FormGroup>,
                                <FormGroup row>
                                    <Label for="valuePerUserPoints" sm={4}>User Gets (pts)</Label>
                                    <Col sm={8}>
                                        <Input type="number"
                                               name="valuePerUserPoints"
                                               id="valuePerUserPoints"
                                               disabled={true}
                                               value={Math.round((Number(userSplit) || 0) * (Number(fixedRevenue) || 0) * 1000)}/>
                                        <FormText>How much points will user get?</FormText>
                                    </Col>
                                </FormGroup>,
                                    <FormGroup row>
                                        <Label for="selectMethod" sm={4}>Callback Method</Label>
                                        <Col sm={8}>
                                            <CustomInput type="select" name="selectMethod"
                                                         id='selectMethod'
                                                         defaultValue={method}
                                                         onChange={(e) => this.setState({ method: e.target.value})}>
                                                <option key='GET' value='GET'>GET</option>
                                                <option key='POST' value='POST'>POST</option>
                                            </CustomInput>
                                            <FormFeedback>Method is required</FormFeedback>
                                            <Row><Col sm={12}><FormText>What http method to use for sending leads?</FormText></Col></Row>
                                        </Col>
                                    </FormGroup>,
                                    <FormGroup row>
                                        <Label for="url" sm={4}>Callback Url</Label>
                                        <Col sm={8}>
                                            <Input name="url"
                                                   id="url"
                                                   defaultValue={url}
                                                   onChange={(e) => this.setState({ url: e.target.value })}
                                                   invalid={(!url || url.length === 0) && validateForm}/>
                                            {(!url || url.length === 0) && <FormFeedback>Callback url is required</FormFeedback> }
                                            <FormText>Callback url leads are sent to. E.g. www.getdabbl.com?phone=[NUMBER]&firstname=[FNAME]&lastname=[LNAME]</FormText>
                                        </Col>
                                    </FormGroup>,
                                    <FormGroup row>
                                        <Label for="requiredFields" sm={4}>Required Fiels</Label>
                                        <Col sm={8}>
                                            <Input name="requiredFields"
                                                   id="requiredFields"
                                                   defaultValue={requiredFields}
                                                   onChange={(e) => this.setState({ requiredFields: e.target.value })}/>
                                            <FormText>What fields are to be filled before sending the lead? Possible values are FNAME, LNAME, EMAIL, NUMBER, ZIP</FormText>
                                        </Col>
                                    </FormGroup>,
                                    <FormGroup row>
                                        <Label for="blockedDomains" sm={4}>Blocked domains</Label>
                                        <Col sm={8}>
                                            <Input name="blockedDomains"
                                                   id="blockedDomains"
                                                   defaultValue={blockedDomains}
                                                   onChange={(e) => this.setState({ blockedDomains: e.target.value })}/>
                                            <FormText>What email domains should be blocked?</FormText>
                                        </Col>
                                    </FormGroup>
                                ]
                            }
                            {type === 'PC_MULTIPLE' &&
                            <FormGroup row>
                                <Label for="upcs" sm={4}>Upload Codes</Label>
                                <Col sm={8}>
                                    <Label for="codes_upload" className="btn">Upload List</Label>
                                    <Input type="file" name="file" id="codes_upload" accept='.csv'
                                           invalid={(isCreate && count === 0 && shouldSubmitCodes) && validateForm}
                                           onChange={(e) => this.handleFileUploadChange(e)} style={{display: 'none'}}/>

                                    {codes.length === 0 && !isCreate &&
                                    <span> {`${count} codes`} </span>
                                    }
                                    {codes.length > 0 &&
                                    <span> {`${codes.length} codes to upload`} </span>
                                    }
                                    {(codes.length > 0 && isCreate) &&
                                    <Button2 color="link" onClick={(e) => this.clearCodes(e)}> Clear Codes </Button2>
                                    }
                                    <FormFeedback>Promo Codes are required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Upload file in .csv format, all codes with alphanumeric
                                        characters will be processed.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                                    }
                            {type === 'PC_SINGLE' &&
                            <FormGroup row>
                                <Label for="code" sm={4}>Single Code</Label>
                                <Col sm={8}>
                                    <Input name="code"
                                           id="code"
                                           defaultValue={codes && codes.length > 0 ? codes[0] : ''}
                                           onChange={(e) => this.setState({ codes: e.target.value ? [e.target.value] : [], shouldSubmitCodes: true })}
                                           invalid={(!codes || codes.length === 0) && validateForm}/>
                                    {(!codes || codes.length === 0) && <FormFeedback>Single code is required</FormFeedback> }
                                    <FormText>What single code should be distributed to the user?</FormText>
                                </Col>
                            </FormGroup>
                            }
                            <FormGroup row>
                                <Label for="ctaCopy" sm={4}>CTA Copy</Label>
                                <Col sm={8}>
                                    <Input name="ctaCopy"
                                           id="ctaCopy"
                                           defaultValue={ctaCopy}
                                           onChange={(e) => this.setState({ ctaCopy: e.target.value })}
                                           invalid={(!ctaCopy || ctaCopy.length === 0 || ctaCopy.length > 16) && validateForm}/>
                                    {(!ctaCopy || ctaCopy.length === 0 || ctaCopy.length > 16) && <FormFeedback>CTA Copy is required with length of no more than 16 characters</FormFeedback> }
                                    <FormText>What should the CTA on pop-up read? Example: "Redeem Now" or "Sign-up Now"</FormText>
                                </Col>
                            </FormGroup>
                            {type !== 'LEADGEN' &&
                                <FormGroup row>
                                    <Label for="ctaUrl" sm={4}>CTA Url</Label>
                                    <Col sm={8}>
                                        <Input name="ctaUrl"
                                               id="ctaUrl"
                                               defaultValue={ctaUrl}
                                               onChange={(e) => this.setState({ctaUrl: e.target.value})}
                                               invalid={(!ctaUrl || ctaUrl.length === 0) && validateForm}/>
                                        {(!ctaUrl || ctaUrl.length === 0) &&
                                            <FormFeedback>CTA Url is required</FormFeedback>}
                                        <FormText>Provide full URL for CTA</FormText>
                                    </Col>
                                </FormGroup>
                            }
                            <FormGroup color={ctaColorValid ? '' : 'danger'} row>
                                <Label for='ctaColor' sm={4}>CTA Color</Label>
                                <Col sm={8}>
                                    <ColorInput
                                        id='ctaColor'
                                        name='ctaColor'
                                        defaultValue={ctaColor}
                                        placeholder='#FF00FF'
                                        onChange={this.handleColorChange.bind(this)}
                                    />
                                    {!ctaColorValid && validateForm &&
                                    <FormText color='danger'>Color is required</FormText>
                                    }
                                    <Row><Col sm={12}><FormText>Background color for the CTA button</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidPromotion()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditPromotion;



// WEBPACK FOOTER //
// ./src/routes/EditPromotion/components/EditPromotion.js